import React from "react";
import EmailIcon from "@mui/icons-material/Email";
import PhoneIcon from "@mui/icons-material/Phone";
import HelpOutlineIcon from "@mui/icons-material/HelpOutline";

const ContactButtons: React.FC = () => {
  const handleEmailClick = () => {
    window.location.href = "mailto:info@supportdecor.com";
  };

  const handlePhoneClick = () => {
    window.location.href = "tel:+201558585914";
  };

  const handleWhatsAppClick = (message: string) => {
    const encodedMessage = encodeURIComponent(message);
    window.open(
      `https://wa.me/201558585914?text=${encodedMessage}`,
      "_blank"
    );
  };

  return (
    <div
      className="w-full flex text-[24px] font-bold max-md:flex-col justify-center text-start items-center mt-24"
      dir="rtl"
    >
      {/* Email Button */}
      <div
        className="bg-secondary p-4 px-20 w-full max-md:mx-3 flex items-center justify-start gap-3 max-md:w-full cursor-pointer"
        onClick={handleEmailClick}
      >
        <div className="bg-white p-2 flex justify-center items-center">
          <EmailIcon fontSize="large" className="text-secondary" />
        </div>
        <span className="font-bold text-[24px]">ارسل بريد الكتروني</span>
      </div>

      {/* Call Us Button */}
      <div
        className="bg-accent p-4 px-20 w-full max-md:mx-3 flex items-center justify-start gap-3 max-md:w-full cursor-pointer"
        onClick={handlePhoneClick}
      >
        <div className="bg-white p-2 flex justify-center items-center">
          <PhoneIcon fontSize="large" className="text-accent" />
        </div>
        <span className="font-bold text-[24px]">
          اتصل بنا
          <span className="text-lg font-bold mx-4">+201558585914</span>
        </span>
      </div>

      {/* Any Questions Button */}
      <div
        className="bg-primary p-4 px-20 w-full max-md:mx-[10px] flex items-center justify-start gap-3 max-md:w-full cursor-pointer"
        onClick={() =>
          handleWhatsAppClick("مرحبًا، أود طلب خدمة التصميمات الداخلية.")
        }
      >
        <div className="bg-white p-2 flex justify-center items-center">
          <HelpOutlineIcon fontSize="large" className="text-primary" />
        </div>
        <span className="font-bold text-[24px]">أي سؤال؟</span>
      </div>
    </div>
  );
};

export default ContactButtons;
